import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    'count'
  ]

  connect() {
    const parentFrame = this.element.closest('#dashboard_content');
    if (parentFrame && this.hasCountTarget) {
      this.countTarget.textContent = parentFrame.dataset.localRecordingCount;
    }
  }
}